export default "__VITE_ASSET__CUSwxS40__"